// Splits the PandaDoc template list into the two picker sections.
//
// The reliable signal is a template's *roles* — a `Client` role means it's
// customer-facing; a `Subcontractor`/`Sub Contractor` role means it's an internal
// contractor doc. (`Contractor` alone = MFR itself, the general contractor, and
// appears in BOTH worlds, so it is NOT a signal.) The templates-list API doesn't
// return roles, so we cache the decision here. When new templates appear, check
// their roles (templates_details_get) and add the id below.

export type TemplateSection = 'customer' | 'contractor';

// Verified via templates_details_get to carry a Subcontractor/Sub Contractor role.
const CONTRACTOR_TEMPLATE_IDS = new Set<string>([
  'ER2rEmHuqBnsrV74FVuDUA', // fw9 2026 template - Sub Welcome Package  (Contractor + Sub Contractor)
  'UH5Fyp3djVrXZL6zvE9YtD', // Work Order SUB_CX Template               (… + Subcontractor)
  'zZ4bK6xtGbeaNNZRzopzNT', // EXTRA WORK FOR SUB CONTRACTOR            (… + Sub Contactor)
  'e26Et6oAV3vmHrzKEf7fvV', // Welcome Package For Sales / PM  (roles: Subcontractor + Contractor -- the
                            // name has no "sub" so the regex missed it; verified via templates_details_get.
                            // Left in Customer, a send adds no subcontractor signer -> the Sub fields go unsigned.)
]);

// "sub"-ish names that are actually client-signed (verified `Client` role) — pin
// them to the customer section so the name fallback below doesn't misfile them.
const CUSTOMER_TEMPLATE_IDS = new Set<string>([
  'Cb46Fxa3JnPzRFDX9gNTA9', // Payments for Vendors & Subcontractors — roles: Client + Sales Rep
]);

// Fallback for sub templates added later (copies, W-9s, vendor-pay variants).
const CONTRACTOR_NAME_RE =
  /sub-?\s?cont|sub welcome|work order sub|\bfw-?9\b|\bw-?9\b|pay on friday|extra work for sub|subcontractor bills/i;

export function templateSection(t: { id: string; name: string }): TemplateSection {
  if (CUSTOMER_TEMPLATE_IDS.has(t.id)) return 'customer';
  if (CONTRACTOR_TEMPLATE_IDS.has(t.id)) return 'contractor';
  return CONTRACTOR_NAME_RE.test(t.name) ? 'contractor' : 'customer';
}
